import {
  Box,
  DeleteIcon,
  Div,
  H5,
  Icon,
  Img,
  renderVDriveIcon,
  renderVDriveProviderName,
} from '@vgrubs/components';

export const BannedAssignmentDeliveryProvider = ({
  provider,
  setBannedProviders,
  index,
}) => {
  const handleDeleteItem = () => {
    setBannedProviders((prev) => prev.filter((_, i) => i !== index));
  };
  return (
    <Box $flex $alignCenter $between>
      <Div $flex $alignCenter $gap="16px">
        <Div $flexNone $width="32px" $height="32px">
          <Img
            alt=""
            src={renderVDriveIcon(provider)}
            $width="32px"
            $widthSM="32px"
          />
        </Div>
        <H5 $mb="0">{renderVDriveProviderName(provider)}</H5>
      </Div>
      <Icon $size="32" $pointer onClick={handleDeleteItem}>
        <DeleteIcon />
      </Icon>
    </Box>
  );
};
